class ShopifyCartManager {
  constructor(checkboxId, selectClass) {
    this.checkbox = document.getElementById(checkboxId);
    this.selectElement = document.querySelector(selectClass);
    this.init();
  }

  // Initialize event listener
  init() {
    if (this.checkbox) {
      this.checkbox.addEventListener('change', () => this.handleCheckboxChange());
    } else {
      console.error('Checkbox not found.');
    }
  }

  // Handle checkbox state change
  handleCheckboxChange() {
    console.log('Checkbox state changed');

    if (this.checkbox.checked) {
      if (this.selectElement) {
        const id = this.getSelectedProductId();
        if (id) {
          this.addToCart(id);
        } else {
          
          console.error('No product ID found.');
        }
      } else {
        let id = document.querySelector(".cstm-product-content").getAttribute("id");
          this.addToCart(id);
        console.error('Select element not found.');
      }
      console.log('Checkbox is checked');
    } else {
       if (this.selectElement) {
        const id = this.getSelectedProductId();
        if (id) {
          this.removeProduct(id);
        } else {
          
          console.error('No product ID found.');
        }
      } else {
        let id = document.querySelector(".cstm-product-content").getAttribute("id");
          this.removeProduct(id);
        console.error('Select element not found.');
      }
      
      console.log('Checkbox is not checked');
    }
  }

  // Get selected product ID from the dropdown
  getSelectedProductId() {
    const selectedOption = this.selectElement.options[this.selectElement.selectedIndex];
    return selectedOption ? selectedOption.getAttribute("id") : null;
  }

  // Add product to the cart
  async addToCart(productId) {
    
    const formData = {
      items: [{ id: productId, quantity: 1 }]
    };
console.log("Id" , formData)
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const responseText = await response.json();
      // console.log('Product Added (Text):', responseText);
    document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem', {}));
              document.body.dispatchEvent(new CustomEvent('baseline:modalcart:itemcountupdate', {}));
      // Fetch updated cart details
      // this.getCartData();

    } catch (error) {
      console.error('Error adding product to cart:', error);
    }
  }

  async removeProduct(productId) {

     fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        var giftProductID = document.getElementById('gift-label')?.getAttribute('data-product-name');
        var giftProductHandle = document.getElementById('gift-label')?.getAttribute('data-product-handle');
        var giftProduct = cart.items.find(item => item.id == productId);
      // console.log("giftProduct", giftProduct.product_id)
        if (giftProduct) {
          
            var cartItemsList = document.querySelectorAll('.drawer-items .bg-border-bottom ');
            if(cartItemsList){
              cartItemsList.forEach(function(item) {
                  var itemHandle = item.getAttribute('data-cart-item-id');
                console.log("itemHandle" , itemHandle)
                  if (itemHandle == giftProduct.product_id) {
                      // localStorage.setItem('GiftNoteVal', '');
                      // document.querySelector('.mini-cart__note textarea').value = '';
                      item.querySelector('button').click();
                      // localStorage.setItem('GiftLabel', 'Gift wrap this order (+ $5)');
                  }
              });
            }
            // var cartPageItemsList = document.querySelectorAll('.cart-items tbody .cart-item');
            // if(cartPageItemsList){
            //   cartPageItemsList.forEach(function(item) {
            //       var itemHandle = item.getAttribute('data-handle');
            //       if (itemHandle == giftProductHandle) {
            //           // localStorage.setItem('GiftNoteVal', '');
            //           document.querySelector('.mini-cart__note textarea').value = '';
            //           item.querySelector('cart-remove-button').click();
            //           localStorage.setItem('GiftLabel', 'Gift wrap this order (+ $5)');
            //       }
            //   });
            // }
        }
    });
//   const formData = {
//       items: [{ id: productId, quantity: '0' }]
//     };
// console.log("productId" , formData)
//     try {
//       const response = await fetch('cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       });

//       const responseText = await response.json();
//       console.log('Product Added (Text):', responseText);
//     document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem', {}));
//               document.body.dispatchEvent(new CustomEvent('baseline:modalcart:itemcountupdate', {}));
//       // Fetch updated cart details
//       // this.getCartData();

//     } catch (error) {
//       console.error('Error adding product to cart:', error);
//     }
}
  
  // Fetch and log updated cart data
//   async getCartData() {
//     try {
//       const response = await fetch(window.Shopify.routes.root + 'cart.js');
//       const cartData = await response.json();
//       this.updateDrawer(cartData)
//       // console.log('Updated Cart (Text):', cartData);
//     } catch (error) {
//       console.error('Error fetching cart data:', error);
//     }
//   }
//   updateDrawer(cartData) {
//     const target = document.querySelector(".drawer-items");
// console.log("item" , cartData )
//     cartData.items.forEach((item , index) => {
//       const itemElement = document.createElement('div');
//       itemElement.classList.add('flex', 'py-4', 'bg-border-bottom', 'transition', 'bg-scheme-background');
//       itemElement.setAttribute(":class", "{ 'opacity-50 cursor-wait': item.updating }");
//       itemElement.setAttribute(":data-cart-item-index", "(index + 1)");
//       itemElement.setAttribute(":data-cart-item-key", "item.key");
//       itemElement.setAttribute(":data-cart-item-id", "item.product_id");
//        itemElement.setAttribute("data-cart-row",''); 
//       itemElement.setAttribute("data-cart-item-index", index);
//       itemElement.setAttribute("data-cart-item-key", item.key );
//       itemElement.setAttribute("data-cart-item-id", item.id );
//       // data-cart-item-id
//       itemElement.innerHTML = `
// <div class="flex-shrink-0 w-16 md:w-20 mr-1">
                    
//                     <a :href="item.url" class="block" aria-hidden="true" tabindex="-1" href="${item.url}">
//                       <img class="w-full text-transparent" :src="getSizedImageUrl(item.featured_image.url, '110x')" :srcset="getCartImgSrcset(item.featured_image.url)" :width="item.featured_image.width" :height="item.featured_image.height" :alt="item.product_title" sizes="(min-width: 48em) 5rem, 3.5rem" src="${item.image ? item.image : item.product.featured_image}" /> 
//                     </a>
//                   </div>
//       `
//       console.log("item" , itemElement )
//       // console.log("get" , )
//     })
    
//   }
}

// Initialize the class
new ShopifyCartManager('add', '.cstm-product-content select');
document.addEventListener('DOMContentLoaded', () => {

  
//   function checkGiftAdd(id) {
//        fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//         var giftProductID = document.getElementById('gift-label')?.getAttribute('data-product-name');
//         var giftProductHandle = document.getElementById('gift-label')?.getAttribute('data-product-handle');
//         var giftProduct = cart.items.find(item => item.id == productId);
//       console.log("giftProduct", giftProduct.product_id)
//         if (giftProduct) {
          
//             var cartItemsList = document.querySelectorAll('.drawer-items .bg-border-bottom ');
//             if(cartItemsList){
//               cartItemsList.forEach(function(item) {
//                   var itemHandle = item.getAttribute('data-cart-item-id');
//                 console.log("itemHandle" , itemHandle)
//                   if (itemHandle == giftProduct.product_id) {
//                     document.querySelector("#add").checkbox.checked = true;
//                   }
//               });
//             }

//         }
//     });
// }
  
// let pro = document.querySelectorAll(".cstm-product-content select");
//   console.log("pro" , pro)
// if (pro.length > 0) {

//   const selectedOption = pro.selectElement.options[this.selectElement.selectedIndex];
//   let id = selectedOption ? selectedOption.getAttribute("id") : null;
//   checkGiftAdd(id) 
// }
// else {
//   let id = document.querySelector(".cstm-product-content").getAttribute("id");
//   checkGiftAdd(id)
// }

})